export const ACCOUNTS = 'accounts';
